import { useCallback } from 'react'
import ApiService from '../../../services/ApiService'

const InteractorFundFeeSearch = () => {
  const fundFeeSearch = useCallback((payload, callback, loading) => {
    ApiService.jsonRequest('/fund-fee/search', payload, response => {
      if (response.status_code === 200) {
        loading(false)
        callback(response.data)
      }
    })
  }, [])
  return { fundFeeSearch }
}

export default InteractorFundFeeSearch
